import FlagIconsContainer from "../../components/icon/flagIcon";

const FlagIcon = () => {
  return <FlagIconsContainer />;
};

export default FlagIcon;
